import { render } from "./ExcelImport.vue?vue&type=template&id=bf2358be"
import script from "./ExcelImport.vue?vue&type=script&lang=js"
export * from "./ExcelImport.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__